<template>
  <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
    <v-card-text v-if="funcionario.nueva_asignacion || form.editar">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex md3 v-if="this.form.id_estado != 1">
            <v-text-field
              v-model="form.fecha_desde"
              :rules="$validate(['required'])"
              required
              label="Fecha de incorporación"
              type="date"
              @change="alertarAprobacion()"
              @input="esFeriadoOFinDeSemana(form.fecha_desde,1)"
            >
            </v-text-field>
          </v-flex>
          <v-flex
            md3
            v-if="this.form.id_estado != 1 && this.form.id_estado != 64"
          >
            <v-autocomplete
              :items="itemsDisponibles"
              item-text="nro_item"
              :item-value="(val) => val.nro_item"
              :rules="$validate(['required'])"
              required
              label="ITEM"
              :loading="loading"
              @change="cargarDatos()"
            @input="cargarCargoYPuesto(form.nro_item)"
              v-model="form.nro_item"
            />
          </v-flex>
          <v-flex
            md12
            v-if="this.form.id_estado != 1 && this.form.id_estado != 64"
          >
            <v-text-field
              v-model="form.padres_unidad"
              :rules="$validate(['required'])"
              required
              label="Unidades padre"
              disabled
            >
            </v-text-field>
          </v-flex>
          <v-flex
            md6
            v-if="this.form.id_estado != 1 && this.form.id_estado != 64"
          >
            <v-autocomplete
              :items="unidades"
              item-text="nombre_unidad"
              :item-value="(val) => parseInt(val.id)"
              label="Unidad"
              v-model="form.id_unidad"
              :rules="$validate(['required'])"
              @change="obtenerOrganigrama"
              required
              disabled
            >
              <template v-slot:item="data">
                <v-tooltip left class="tree--rounded">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      {{ data.item.nombre_unidad }}
                    </div>
                  </template>
                  <v-treeview
                    class="white--text pa-1"
                    v-model="tree"
                    :open="[1, 2]"
                    :items="data.item.organigrama"
                    item-key="id"
                  >
                    <template v-slot:prepend="{ item }">
                      <v-icon class="white--text">
                        {{ item.icon }}
                      </v-icon>
                    </template>
                  </v-treeview>
                </v-tooltip>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex
            xs4
            v-if="this.form.id_estado != 1 && this.form.id_estado != 64"
          >
            <v-autocomplete
              v-model="form.id_cargo"
              :items="cargos"
              item-text="cargo"
              :item-value="(val) => parseInt(val.id_cargo)"
              label="Seleccione Cargo"
              disabled
            ></v-autocomplete>
          </v-flex>
          <v-flex
            xs4
            v-if="this.form.id_estado != 1 && this.form.id_estado != 64"
          >
            <v-autocomplete
              v-model="form.id_puesto"
              :items="puestos"
              item-text="denominacion"
              :item-value="(val) => parseInt(val.id)"
              label="Seleccione Puesto"
              :rules="$validate(['required'])"
              disabled
            ></v-autocomplete>
          </v-flex>
          <v-flex
            md4
            v-if="this.form.id_estado != 1 && this.form.id_estado != 64"
          >
            <v-autocomplete
              :items="itemsDisponibles"
              item-text="sueldo"
              :rules="$validate(['required'])"
              required
              disabled
              label="Sueldo"
              :loading="loading"
              v-model="form.sueldo"
            />
          </v-flex>
          <v-flex md3 v-if="this.form.id_estado == 1">
            <v-text-field
              v-model="form.fecha_desde"
              :rules="$validate(['required'])"
              required
              label="Fecha de incorporación"
              type="date"
              @change="alertarAprobacion()"
              @input="esFeriadoOFinDeSemana(form.fecha_desde)"
            >
            </v-text-field>
          </v-flex>
          <v-layout wrap v-if="this.form.id_estado == 1">
            <v-flex md12>
              <strong>Nro de item:</strong> {{ form.nro_item }}
            </v-flex>
            <v-flex md12>
              <strong>Nombre unidad:</strong> {{ form.unidad }}
            </v-flex>
            <v-flex md12> <strong>Cargo:</strong> {{ form.cargo }} </v-flex>
            <v-flex md6> <strong>Puesto:</strong> {{ form.puesto }} </v-flex>
            <v-flex md6> <strong>Sueldo:</strong> {{ form.sueldo }} </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions v-if="funcionario.nueva_asignacion || form.editar">
      <small class="error--text text-required"
        >* Los campos son obligatorios *</small
      >
      <v-spacer></v-spacer>
      <v-btn @click="close()">
        <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
      </v-btn>
      <v-btn
        v-show="!fecha_futuro"
        color="primary"
        type="submit"
        :disabled="!valid"
        :loading="loading"
      >
        <v-icon dark>check</v-icon> {{ $t("common.save") }}
      </v-btn>
    </v-card-actions>
    <v-card-text v-if="!funcionario.nueva_asignacion && !form.editar">
      <v-container>
        <v-layout>
       
          <small class="error--text text-required"
            >* No puede realizar esta tarea porque el servidor publico ya tiene
            una movilidad activa *</small
          >
        </v-layout>
      </v-container>
    </v-card-text>
  </v-form>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  mixins: [validate],
  props: [
    "id_tipo_justificacion",
    "funcionario",
    "unidades",
    "cargos",
    "puestos",
    "data",
  ],
  data() {
    return {
      valid: false,
      loading: false,
      form: this.data,
      itemsDisponibles: [],
      tipo_cargo: [],
      tipo_puesto: [],
      nueva_asignacion: true,
      obtenerOrganigrama: [],
      tree: [],
      fecha_futuro: false,
      bandera_fecha: false,
    };
  },
  mounted() {
    this.obtenerItemsDisponibles();
    if (this.form && this.form.nro_item) {
      this.form.nro_item = this.form.nro_item.toString();
    }
  },
  methods: {
    async esFeriadoOFinDeSemana(fecha, valor){},
    // Metodo para determinar si es feriado o fin de semana  this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
         async esFeriadoOFinDeSemanaVerificar(fecha, valor) {
      try {
        if (valor == 1) {
          this.bandera_fecha = false;
        }
        let usuario = this.$storage.get("user");
        if (!fecha && valor == 1) {
          this.$message.info("Fecha inválida ",fecha);
          this.bandera_fecha = true;
          return true;
        } else {
          //verificando que la fecha es o no dia habil
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT general.fn_cuenta_finde_feriado_por_persona('${fecha}', '${fecha}', ${usuario.id_persona})"){
                  respuesta
                }
              }
            `,
          });
          if (respuesta.runQuery.respuesta) {
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_cuenta_finde_feriado_por_persona;

            if (respuesta == 1 && valor == 1) {
              this.$message.info(`La fecha ${this.$moment(fecha).format('DD/MM/YYYY')} cae en fin de semana o feriado`);
              this.bandera_fecha = true;
              return true;
            }

            return false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async cargarCargoYPuesto(nro_item){

    },
    async alertarAprobacion() {

      if (this.form.id_estado == 64) {
        if (
          this.$moment() >= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono la fecha actual o una fecha pasada, por lo tanto la movilidad se aprobara si la guarda"
          );
        }
      }
      if (this.form.id_estado == 1 || this.form.id_estado == 53) {
        if (
          this.$moment() <= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono una fecha a futuro, por lo cual no puede guardar la movilidad, ya que fue aprobada"
          );
          this.fecha_futuro = true;
        } else {
          this.fecha_futuro = false;
        }
      }
    },
    cargarDatos() {
      const elemento = this.itemsDisponibles.find(
        (item) => item.nro_item === this.form.nro_item
      );
      console.log("elemento: ",elemento)
      if (elemento) {
        console.log(elemento, "----------", elemento.sueldo);
        this.form.id_unidad = elemento.id_unidad;
        this.form.id_cargo = elemento.id_cargo;
        this.form.sueldo = elemento.sueldo;
        this.form.padres_unidad = elemento.padres_unidad;
        this.form.id_puesto=elemento.id_puesto;
      
      } else {
        this.form.id_unidad = "";
        this.form.id_cargo = "";
        this.form.id_puesto = "";
        this.form.sueldo = "";
        this.form.padres_unidad = "";
      }
    },
    async obtenerItemsDisponibles() {
      try {
        this.loading = true;
        let res = await this.$service.graphql({
          query: `
            query{
              vItemCargos(libre: 1){
                rows{
                   id_item
                  nro_item
                  nombre_unidad
                  cargo
                  id_cargo
                  sueldo
                  libre
                  id_unidad
                  padres_unidad
                  id_puesto
                  puesto
                }
              }
            }
          `,
        });
        this.itemsDisponibles = res.vItemCargos.rows;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      let user = this.$storage.get("user");
      let validacion_fecha=await this.esFeriadoOFinDeSemanaVerificar(this.form.fecha_desde,1)
          if (validacion_fecha ) {
            return;
          }
      if (this.form.editar) {
        try {
          if (this.$refs.form.validate()) {
            this.loading = true;
            console.log(`
                query{
                  runQuery(consulta: "SELECT movilidad.fn_modifica_movilidad_interinato_estado(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${this.form.id_puesto}, ${this.form.id_cargo}, ${this.form.nro_item}, ${this.id_tipo_justificacion},null,${this.form.id_estado})"){
                    respuesta
                  }
                }
              `);
            let respuesta = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_modifica_movilidad_interinato_estado(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${this.form.id_puesto}, ${this.form.id_cargo}, ${this.form.nro_item}, ${this.id_tipo_justificacion},null,${this.form.id_estado})"){
                    respuesta
                  }
                }
              `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_modifica_movilidad_interinato_estado;
            let resps = respuesta.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.$message.success(resps);
              this.close();
            } else {
              this.$message.error(resps);
              this.loading = false;
            }
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          if (this.$refs.form.validate()) {
          let validacion_fecha=await this.esFeriadoOFinDeSemanaVerificar(this.form.fecha_desde,1)
          if (validacion_fecha) {
            return;
          }
            this.loading = true;
            console.log(`
                query{
                  runQuery(consulta: "SELECT movilidad.fn_alta_movilidad(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${this.form.id_puesto}, ${this.form.id_cargo}, ${this.form.nro_item}, ${this.id_tipo_justificacion})"){
                    respuesta
                  }
                }
              `);
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_alta_movilidad(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${this.form.id_puesto}, ${this.form.id_cargo}, ${this.form.nro_item}, ${this.id_tipo_justificacion})"){
                    respuesta
                  }
                }
              `,
            });
            let resp = res.runQuery.respuesta[0].fn_alta_movilidad;
            let resps = resp.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.$message.success();
            } else {
              this.$message.error(resps);
            }
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async obtenerItem() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              items(nro_item: "${this.form.nro_item}"){
                rows{
                  id
                }
              }
            }
          `,
        });
        return parseInt(res.items.rows[0].id);
      } catch (error) {
        console.log(error);
      }
    },
    //  async obtenerUnidades() {
    //   try {
    //     let res = await this.$service.graphql({
    //       query: `
    // 				query{
    // 					unidads(id_estado: 17, id_entidad: 35, nivel: 3){
    // 						rows{
    // 							id
    // 							nombre_unidad
    // 						}
    // 					}
    // 				}
    // 			`
    //     });
    //     this.unidades = res.unidads.rows;
    //     this.obtenerOrganigrama(res.unidads.rows);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // obtenerOrganigrama(unidades) {
    //   Promise.all(
    //     unidades.map(uni => {
    //       return this.$service.graphql({
    //         query: `
    //         query{
    //           fnPadresUnidad(id_unidad: ${parseInt(uni.id)}, id_entidad: 35){
    //             respuesta
    //           }
    //         }
    //       `
    //       });
    //     })
    //   )
    //     .then(organigramas => {
    //       console.log("organigramas", organigramas);
    //       const unidadeConOrganigrama = unidades.map((uni, index) => {
    //         return {
    //           ...uni,
    //           organigrama: this.treeObtenerOrganigrama(
    //             organigramas[index].fnPadresUnidad.respuesta.split("|")
    //           )
    //         };
    //       });
    //       console.log("unidadeConOrganigrama", unidadeConOrganigrama);
    //       this.unidades = unidadeConOrganigrama;
    //     })
    //     .catch(err => console.log(err));
    // },
    close() {
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogCrearMovilidad");
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/components/NuevaAsignacion.vue